module.exports = __webpack_public_path__ + "img/otc.d7330474.svg";